import { DatasetDetail } from "~/routes/datasets/datasetId/index/handers/getDatasetDetail.server";
import { cn } from "~/lib/utils";
import type { DatasetSearchResult } from "~/models/getSearchResultDatasets.server";

type MetadataKey = "sampleType" | "perturbationType" | "tissue" | "disease";

export const MetadataPill = ({
  dataset,
  metadataKey,
  classNames = "",
}: {
  dataset: Pick<DatasetSearchResult | DatasetDetail, MetadataKey>;
  metadataKey: MetadataKey;
  classNames?: string;
}) => {
  const commaSeparated = dataset[metadataKey];
  if (!commaSeparated) return null;
  const values = commaSeparated.split(", ").flatMap((value) => value.split("|"));
  return (
    <p
      key={commaSeparated}
      className={cn(classNames, "rounded-full px-2 py-0.5 whitespace-nowrap bg-border")}
    >
      {values.length >= 3 ? `${values.slice(0, 2).join(", ")}, ...` : values.join(", ")}
    </p>
  );
};
